<template>

  <el-container >

      <div v-show="$route.name !== 'phone_guest'">
        <el-menu

            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
          <el-menu-item index="phone">号码管理</el-menu-item>

          <el-submenu index="2" v-if="role===8">
            <template slot="title">管理操作</template>
            <el-menu-item index="dmgt">数据管理</el-menu-item>
            <el-menu-item index="userList">用户列表</el-menu-item>
          </el-submenu>
          <el-menu-item index="logout">退出登录</el-menu-item>

        </el-menu>

<!--        <el-menu-->
<!--            default-active="config"-->
<!--            class="el-aside"-->
<!--            mode="horizontal"-->
<!--            background-color="#545c64"-->
<!--            text-color="#fff"-->
<!--            active-text-color="#ffd04b"-->
<!--            :collapse="isCollapse"-->
<!--            router-->
<!--        >-->

<!--            <div>-->
<!--              <el-button type="text" icon="el-icon-s-unfold" size="medium" @click="clickMenu" style="background-color: #545c64;color: white;margin-left: 15px">{{menuText}}</el-button>-->
<!--            </div>-->


    <!--        <el-menu-item index="/admin">-->
    <!--          <i class="el-icon-box"></i>-->
    <!--          <span slot="title">更新脚本</span>-->
    <!--        </el-menu-item>-->
<!--            <el-menu-item index="/myset">-->
<!--              <i class="el-icon-setting"></i>-->
<!--              <span slot="title">我的资料</span>-->
<!--            </el-menu-item>-->
    <!--        <el-menu-item index="/other">-->
    <!--          <i class="el-icon-s-data"></i>-->
    <!--          <span slot="title">其他设置</span>-->
    <!--        </el-menu-item>-->

<!--            <div v-if="role===8">-->

<!--              <el-menu-item index="/dmgt">-->
<!--                <i class="el-icon-s-grid"></i>-->
<!--                <span slot="title">数据管理</span>-->
<!--              </el-menu-item>-->

<!--              <el-menu-item index="/userList">-->
<!--                <i class="el-icon-s-custom"></i>-->
<!--                <span slot="title">用户列表</span>-->
<!--              </el-menu-item>-->

<!--            </div>-->
<!--            <el-menu-item index="/logout">-->
<!--              <i class="el-icon-switch-button"></i>-->
<!--              <span slot="title">退出登录</span>-->
<!--            </el-menu-item>-->
<!--          </el-menu>-->

      </div>


<!--      <el-header style="height: 30px;">-->
<!--        &lt;!&ndash;        <el-col><el-button type="info" size="small" icon="el-icon-switch-button">退出</el-button></el-col>&ndash;&gt;-->
<!--      </el-header>-->
      <!--        📅📟📠📱📲📳📴☎️🛖🔒🔓🔑🗝️🎗️🎞️🖨️🖥️💻🪪🧮🎥📺🔍📔📚📙📘📗📖📕📒📰📑📊-->
      <el-main >
        <router-view></router-view>
      </el-main>


      <el-footer style="height: 20px;width: 100%"></el-footer>

    </el-container>



</template>

<script>
export default {
  name: "home",

  data() {
    return {
      isCollapse: false,
      role:0,
      menuText:'>',
    };
  },
  created() {
    this.isMobile() ? this.isCollapse = true : this.isCollapse = false;
    this.isCollapse ? this.menuText = ">" : this.menuText = "<";
    this.chkRole();
  },
  computed: {

  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      if(key === 'logout'){
        this.$router.push('/login');
      }else if(key === 'phone'){
        this.$router.push('/phone');
      }else if(key === 'dmgt'){
        this.$router.push('/dmgt');
      }else if(key === 'userList'){
        this.$router.push('/userList');
      }
    },
    clickMenu(){
      this.isCollapse = !this.isCollapse;
      this.isCollapse ? this.menuText = ">" : this.menuText = "<";
    },
    async chkRole() {
      const {data:res} = await this.$ajax.post("/api/admin/chkRole",{account: window.sessionStorage.getItem('account')});
      if (res.code === 200){
        this.role = res.data;
        if(this.role === 0){
          await this.$router.push('/phone');
        }else if(this.role === 8){
          await this.$router.push('/dmgt');
        }else {
          await this.$router.push('/login');
          this.$msgNot.success('登录错误:未知类型');
        }
      }
    }
  }
}
</script>

<style>

.adminstyle{
  color: #7ac7c4;
}
.el-menu-horizontal-demo:not(.el-menu--collapse) {
  width: 100%;
  min-height: 100px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100px;
  min-height: 500px;
}
.el-containerMain{
  /*height: 1000px;*/
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
}
.el-header, .el-footer {
  background-color: #cfcfcf;
  color: #121212;
  text-align: left;
  line-height: 10px;
  height: 10px;
  width: 100px;
  /*border-radius: 30px;*/
  /*box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)*/
}

.el-aside:not(.el-menu--collapse) {
  background-color: #222D32;
  color: #ffffff;
  text-align: left;
  line-height: 50px;
  width: 100%;
  height: 50px;
  min-height: 50px;
}

.el-main {
  background-color: #ffffff;
  color: #222D32;
  text-align: left;
  line-height: 30px;
  height: 100%;
}

body > .el-container {
  margin-bottom: 30px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>

